exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".main-content[data-v-e8d7f366]{text-align:left}.nomore[data-v-e8d7f366]{padding:30px;background-color:#fff}", ""]);

// exports
